import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface Combustible {
  id?: number;
  nombre: string;
}

@Injectable({
  providedIn: 'root',
})
export class CombustibleService {
  private apiUrl =  `${environment.apiUrl}/api/combustible`; 

  constructor(private http: HttpClient) {}

  private manejarError(error: HttpErrorResponse) {
    console.error('❌ Error en la petición:', error);
    let mensaje = 'Ocurrió un error inesperado.';
    if (error.error?.message) {
      mensaje = error.error.message;
    }
    return throwError(() => new Error(mensaje));
  }

  createCombustible(data: Combustible): Observable<Combustible> {
    return this.http.post<Combustible>(this.apiUrl, data, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  getAllCombustibles(): Observable<Combustible[]> {
    return this.http.get<Combustible[]>(this.apiUrl, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  getCombustibleById(id: number): Observable<Combustible> {
    return this.http.get<Combustible>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  updateCombustible(id: number, data: Partial<Combustible>): Observable<Combustible> {
    return this.http.put<Combustible>(`${this.apiUrl}/${id}`, data, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  deleteCombustible(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }
}
